import { i18nMark, Trans } from '@lingui/react'

import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

type IdSwitcherProps = {
  pzn?: string
  ean?: string
  upid?: string
  isbn?: string
  uid: string
}

type LabelAndIdPair = {
  label: string
  id: string
}

/**
 * Label and Id pairing logic
 */
export const genLabelAndIdPair = ({
  pzn,
  ean,
  upid,
  isbn,
  uid,
}: IdSwitcherProps): LabelAndIdPair => {
  if (pzn && isbn) {
    return { label: i18nMark('general.label.pznIsbn'), id: `${pzn}/${isbn}` }
  }
  if (pzn && isbn && ean) {
    return { label: i18nMark('general.label.pznIsbn'), id: `${pzn}/${isbn}` }
  }
  if (pzn && isbn && ean && upid) {
    return { label: i18nMark('general.label.pznIsbn'), id: `${pzn}/${isbn}` }
  }
  if (pzn && ean) {
    return { label: i18nMark('general.label.pznEan'), id: `${pzn}/${ean}` }
  }
  if (pzn) {
    return { label: i18nMark('general.label.pzn'), id: pzn }
  }
  if (isbn) {
    return { label: i18nMark('general.label.isbn'), id: isbn }
  }
  if (ean) {
    return { label: i18nMark('general.label.ean'), id: ean }
  }
  if (upid) {
    return { label: i18nMark('general.label.upid'), id: upid }
  }
  if (uid) {
    return { label: i18nMark('general.label.upid'), id: uid }
  }
  throw new Error('Neither PZN nor EAN nor UPID is available')
}

/**
 * Shows relevant ID based on logic
 * WSPMP-12
 */
const IdSwitcher = ({
  pzn = '',
  ean = '',
  upid = '',
  isbn = '',
  uid = '',
}: // eslint-disable-next-line no-undef
IdSwitcherProps): JSX.Element => {
  const { id, label } = genLabelAndIdPair({ pzn, ean, upid, uid, isbn })
  return (
    <>
      <Trans id={label} />: {id}
    </>
  )
}

export default withShopAndRuntimeConfig(IdSwitcher)
